<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="input-group input-group-sm">
    <div
      v-if="prependedText"
      class="input-group-prepend"
    >
      <span class="input-group-text font-weight-bolder">{{ prependedText }}</span>
    </div>
    <input
      :id="inputId"
      ref="clipboardInput"
      :type="!showOnlyButton ? 'text' : 'hidden'"
      class="form-control"
      :class="inputClass"
      :readonly="isReadonly"
      :style="{ 'font-family': 'JetBrains Mono' }"
      :size="textToCopy.length"
      :placeholder="placeholder"
    />
    <div
      class="input-group-append"
      :class="showOnlyButton ? 'bg-transparent' : ''"
    >
      <button
        type="button"
        :class="
          showOnlyButton
            ? `btn ${buttonClass} btn-outline-light text-muted disable-hover`
            : `btn ${buttonClass} btn-outline-light`
        "
        class="d-flex align-items-center"
        @click="
          copyText();
          toggleAnimation();
        "
      >
        <i
          :class="copyIcon"
          :style="{ 'font-size': iconSize + 'px' }"
        />
        <span
          class="clipboard__tooltip f6"
          :class="{ visible: isVisibleTooltip && showTooltip }"
          data-tooltip-text="Скопировано!"
        />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GfCustomClipboard',
  props: {
    textToCopy: { default: null },
    prependedText: { default: null },
    showOnlyButton: { default: false },
    isReadonly: { default: true },
    inputId: { default: 'clipboardId' },
    inputClass: '',
    buttonClass: '',
    iconSize: {
      type: Number,
      default: 20
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isVisibleTooltip: false,
      isVisibleSuccess: false
    };
  },
  computed: {
    copyIcon() {
      if (this.isVisibleSuccess) {
        return 'gf-icon gf-icon-check';
      }
      return 'gf-icon gf-icon-copy';
    }
  },
  watch: {
    textToCopy() {
      this.changeCopiedText();
    }
  },
  mounted() {
    this.changeCopiedText();
  },
  methods: {
    changeCopiedText() {
      this.$refs.clipboardInput.value = this.textToCopy;
    },
    copyText() {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(this.$refs.clipboardInput.value);
      } else {
        this.$refs.clipboardInput.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          console.log(err);
        }
      }
    },
    toggleAnimation() {
      this.isVisibleTooltip = true;
      this.isVisibleSuccess = true;
      setTimeout(() => {
        this.isVisibleTooltip = false;
        this.isVisibleSuccess = false;
      }, 2500);
    }
  }
};
</script>
<style lang="scss" scoped>
.clipboard__tooltip {
  position: relative;

  &::before {
    content: attr(data-tooltip-text);
    position: absolute;

    bottom: 2rem;
    left: -2.5rem;

    padding: 0.35rem;
    border-radius: var(--border-radius);
    background: var(--black);
    color: #fff;
    text-align: center;

    display: none;
    opacity: 0;
  }

  &::after {
    content: '';
    position: absolute;

    bottom: 1.25rem;

    border: 0.4rem solid var(--black);
    border-color: var(--black) transparent transparent transparent;

    display: none;
    opacity: 0;
  }
}

.visible,
.visible::before,
.visible::after {
  display: block;
  opacity: 1;
  animation: fadeInOut 2s ease-in-out forwards;
}

.disable-hover {
  border: 0 !important;
}

.disable-hover:hover {
  color: var(--dark) !important;
  background-color: transparent !important;
}

.disable-hover:focus {
  box-shadow: none !important;
}

.disable-hover:active {
  color: var(--dark) !important;
  background-color: var(--light) !important;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
